import {useEffect, useState, useSyncExternalStore} from 'react'

import {getLockedSnapshot, sealLocked, subscribeLocked} from '../lockedTools'

const TICK = 1000

/**
 * Locked's session in this tab, with the seconds left before it reseals, counted down a second at a
 * time while it is open. It reseals here when the count runs out: the API lets its own session go
 * at the same moment, so nothing needs saying to it.
 */
const useLocked = () => {
  const {token, resealAfter, relocksAt} = useSyncExternalStore(subscribeLocked, getLockedSnapshot)
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!relocksAt) return

    const timer = setInterval(() => {
      if (Date.now() >= relocksAt) sealLocked()
      setNow(Date.now())
    }, TICK)

    return () => clearInterval(timer)
  }, [relocksAt])

  return {
    open: Boolean(token),
    resealAfter,
    remaining: relocksAt ? Math.max(0, Math.ceil((relocksAt - now) / 1000)) : 0
  }
}

export default useLocked
